import app_version from '@/version'
import WX_API from '@/utils/wx_api'
const { APP_MODE, CITY } = process.env

// const { model, system, brand, SDKVersion, platform } = wx.getSystemInfoSync()

const enabled_log = APP_MODE !== 'development'

const getUserId = () => {
    const KEY = 'gft_uuid'
    let uuid = WX_API.getStorageSync(KEY)
    if (!uuid) {
        let s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
        uuid = `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4() + s4() + s4()}`
        wx.setStorage({
            key: KEY,
            data: uuid
        })
    }
    return uuid
}

export default (...args) => {
    console.log('GFT--LOG', args)
}

export const sendCtmEvtLog = (evt_name, d_paras) => {
    if (!evt_name) {
        return
    }
    sendUserLog('fc_event_record', {
        d_key: evt_name,
        d_paras,
        d_event: 1
    })
}

export const sendUserLog = (type, options) => {
    if (typeof options.d_paras != 'object') {
        options.d_paras = {}
    }
    options.d_paras.city = CITY
    console.log('GFT--USER--LOG', options)
    if (enabled_log) {
        const user = WX_API.getStorageSync('user') || {}
        options.d_key = options.d_key.toString()
        const task = setTimeout(() => {
            wx.request({
                url: 'https://ff3.gfttek.com/anyfin/ext/rtlog',
                data: [{
                    ...options,
                    d_src: type,
                    d_user: user.uid
                }],
                method: 'POST',
                success: () => {
                    task && clearTimeout(task)
                }
            })
        }, 500)
    }
}

// export const errorLog = (msg) => {
//     console.error('GFT--ERROR--LOG', msg)
//     if (enabled_log) {
//         const user = wx.getStorageSync('user') || null
//         setTimeout(() => {
//             msg += `; ${JSON.stringify({
//                 model, system, brand, SDKVersion, platform, app_version
//             })}`
//             wx.request({
//                 url: 'https://hellfire.rippletek.com/dr_js_error',
//                 data: {
//                     type: `${CITY}_gft_err`,
//                     msg,
//                     uuid: user ? user.uid : getUserId()
//                 },
//                 method: 'POST',
//                 success (res) {
//                 }
//             })
//         }, 1000)
//     }
// }

export const imgErrorLog = (msg) => {
    errorLog(`ImgError: ${msg}`)
}
export const requestErrorLog = (msg, other) => {
    const msgStr = JSON.stringify(msg)
    const otherStr = JSON.stringify(other)
    errorLog(`RequestError: ${msgStr}; ${otherStr};`)
}

export const requestProfileLog = (msg, other) => {
    const segments = [
        'domainLookUp',
        'connect',
        'SSLconnection',
        'request',
        'response'
    ]
    let slow_reason = 'slow_reason:'
    const is_slow_request = segments.some((key) => {
        const time = msg[`${key}End`] - msg[`${key}Start`]
        if (time > 1000) {
            slow_reason += key
            return true
        }
    })
    if (is_slow_request) {
        const msgStr = JSON.stringify(msg)
        const otherStr = JSON.stringify(other)
        errorLog(`RequestProfile: ${slow_reason}; ${msgStr}; ${otherStr};`)
    }
}

export const UserLog = {
    viewBuilding: (building_id, scene) => {
        if (!building_id) {
            return
        }
        sendUserLog('fc_building_view', {
            d_key: building_id,
            d_paras: scene,
            d_event: 1
        })
    },
    buildingAudios (building_id, d_paras) {
        if (!building_id) {
            return
        }
        sendUserLog('fc_building_audio', {
            d_key: building_id.toString(),
            d_paras,
            d_event: 1
        })
    },
    viewBuildingSunlight (building_id, building_name) {
        if (!building_id) {
            return
        }
        sendUserLog('fc_building_sunlight', {
            d_key: building_id,
            d_paras: {
                building_name
            },
            d_event: 1
        })
    },
    viewBuildingVr: (building_id, building_name, vr_link) => {
        if (!building_id) {
            return
        }
        sendUserLog('fc_building_vr_view', {
            d_key: building_id,
            d_paras: {
                building_name,
                vr_link
            },
            d_event: 1
        })
    },
    viewPage: (page) => {
        if (!page) {
            return
        }
        sendUserLog('fc_page_view', {
            d_key: page,
            d_event: 1
        })
    },
    viewCustomBuilding: (buildingId) => {
        sendUserLog('fc_building_custom_view', {
            d_key: buildingId,
            d_event: 1
        })
    },
    viewConsultant: (consultantId) => {
        sendUserLog('fc_consultant_view', {
            d_key: consultantId,
            d_event: 1
        })
    },
    callConsultant: (consultantId) => {
        if (!consultantId) {
            return
        }
        sendUserLog('fc_consultant_call', {
            d_key: consultantId.toString(),
            d_event: 1
        })
    },
    copyConsultant: (consultantId) => {
        if (!consultantId) {
            return
        }
        sendUserLog('fc_consultant_copy', {
            d_key: consultantId.toString(),
            d_event: 1
        })
    },
    contactConsultant: (consultantId) => {
        if (!consultantId) {
            return
        }
        sendUserLog('fc_consultant_contact', {
            d_key: consultantId.toString(),
            d_event: 1
        })
    },
    searchHouse: (searchWord, ids) => {
        sendUserLog('fc_user_search', {
            d_key: searchWord.substring(0, 64),
            d_paras: ids,
            d_event: 0
        })
    },
    regSearch: (buildingId, searchWord) => {
        sendUserLog('fc_reg_results', {
            d_key: buildingId,
            d_paras: searchWord,
            d_event: 0
        })
    },
    lnSearch: (buildingId, searchWord) => {
        sendUserLog('fc_ln_results', {
            d_key: buildingId,
            d_paras: searchWord,
            d_event: 0
        })
    },
    click_feeds_article: (id) => {
        sendUserLog('fc_feeds_article_click', {
            d_key: id.toString(),
            d_event: 0
        })
    },
    click_discuss_group: (id) => {
        if (id) {
           sendUserLog('fc_discuss_group_click', {
                d_key: id.toString(),
                d_event: 0
            })
        }
    },
    vanke_banner: (id, d_event) => {
        if (id) {
            sendUserLog('fc_vanke_banner', {
                 d_key: id.toString(),
                 d_event
             })
         }
    },
    click_article: (type, id) => {
        if (type && id) {
            sendUserLog('fc_article_click', {
                d_key: id.toString(),
                d_event: 0,
                d_paras: {
                    type
                }
            })
        }
    }
}